import { Injectable, signal } from '@angular/core';

export interface ForbiddenDialogState {
  readonly open: boolean;
  readonly message: string;
}

const DEFAULT_MESSAGE = 'You do not have permission to view this.';

/**
 * Global "access denied" dialog shown when the API returns 403. Mounted once
 * at the app root alongside the toast host.
 */
@Injectable({ providedIn: 'root' })
export class ForbiddenDialogService {
  private readonly _state = signal<ForbiddenDialogState>({ open: false, message: DEFAULT_MESSAGE });

  readonly state = this._state.asReadonly();

  show(message?: string): void {
    if (this._state().open) return;
    this._state.set({
      open: true,
      message: message?.trim() || DEFAULT_MESSAGE,
    });
  }

  close(): void {
    this._state.set({ open: false, message: DEFAULT_MESSAGE });
  }
}
